// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════
   BUNDLE DETAIL PANEL
   ════════════════════════════════════════════ */
.bd-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

/* ── Top bar with back button ── */
.bd-topbar {
  display: flex;
  align-items: center;
  padding: 10px 16px 6px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.bd-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.bd-back-btn:hover { background: #f1f5f9; border-color: #2a71ff; color: #2a71ff; }

/* ── Scrollable body ── */
.bd-body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ── Hero card ── */
.bd-hero {
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 16px;
  background: #fff;
}

.bd-hero-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.bd-title {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.3;
  flex: 1;
}

/* availability badge */
.bd-badge {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  padding: 3px 10px;
}
.bd-badge--active   { color: #067647; background: #ecfdf3; }
.bd-badge--expired  { color: #b42318; background: #fef3f2; }
.bd-badge--upcoming { color: #6d4c41; background: #fff8f0; }

.bd-desc {
  margin: 0 0 12px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
}

/* Meta grid: 3-up on wider, 2-up on narrow */
.bd-meta-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px 12px;
}

@media (max-width: 540px) {
  .bd-meta-grid { grid-template-columns: repeat(2, 1fr); }
}

.bd-meta-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.bd-meta-label {
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}
.bd-meta-value {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
}
.bd-meta-value--price {
  font-size: 16px;
  color: #2a71ff;
}
.bd-meta-value--mono {
  font-family: "SFMono-Regular", "Consolas", monospace;
  font-size: 11.5px;
  font-weight: 600;
  color: #475569;
}

/* ── Products section ── */
.bd-products-section { display: flex; flex-direction: column; gap: 10px; }

.bd-section-title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 11px;
  font-weight: 800;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}
.bd-section-count {
  background: #f1f5f9;
  color: #2a71ff;
  font-size: 10.5px;
  font-weight: 700;
  border-radius: 999px;
  padding: 1px 8px;
}

.bd-no-products {
  font-size: 12.5px;
  color: #94a3b8;
  padding: 20px 0;
  text-align: center;
}

/* ── Table ── */
.bd-table-wrap {
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  overflow-x: auto;
  overflow-y: hidden;
}

.bd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11.5px;
  table-layout: fixed;
}

.bd-th {
  padding: 7px 6px;
  background: #f8fafc;
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1.5px solid #e2e8f0;
  white-space: nowrap;
}
/* 5 columns (UOM + Batch + Expiry as pills in Product cell): 38% + 4×15.5% ≈ 100% */
.bd-th--product { text-align: left; width: 38%; min-width: 140px; }
.bd-th--num     { text-align: right; width: 15.5%; }

/* Pill row inside product cell */
.bd-prod-pills  { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }

.bd-tr { transition: background 0.12s; }
.bd-tr:not(:last-child) { border-bottom: 1px solid #f1f5f9; }
.bd-tr:hover { background: #f8fafc; }

.bd-td { padding: 8px 6px; vertical-align: middle; color: #0f172a; }
.bd-td--product { text-align: left; }
.bd-td--center  { text-align: center; }
.bd-td--num     { text-align: right; font-variant-numeric: tabular-nums; font-weight: 600; font-size: 11.5px; }
.bd-td--highlight { color: #2a71ff; font-weight: 700; }

.bd-prod-name    { margin: 0; font-size: 12px; font-weight: 600; color: #0f172a; line-height: 1.3; }
.bd-prod-barcode { margin: 2px 0 0; font-size: 10px; color: #94a3b8; font-family: "SFMono-Regular", monospace; }
.bd-expiry-pill {
  display: inline-block; margin-top: 4px;
  font-size: 10px; font-weight: 600;
  color: #475569; background: #f1f5f9; border: 1px solid #e2e8f0;
  border-radius: 999px; padding: 1px 7px;
}
.bd-expiry-pill--expired {
  color: #b42318; background: #fef3f2; border-color: #fecaca;
}

.bd-batch-pill {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgba(124, 58, 237, 0.08);
  color: #7c3aed;
  border: 1px solid rgba(124, 58, 237, 0.2);
  font-family: ui-monospace, "SFMono-Regular", monospace;
  letter-spacing: 0.02em;
}

.bd-uom-pill {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #059669;
  background: #ecfdf5;
  border-radius: 999px;
  padding: 2px 7px;
}

/* ════════════════════════════════════════════
   DARK THEME
   ════════════════════════════════════════════ */
.dark .bd-topbar      { border-color: #1e293b; }
.dark .bd-back-btn    { background: #1e293b; border-color: #334155; color: #94a3b8; }
.dark .bd-back-btn:hover { background: #0f172a; border-color: #3b82f6; color: #60a5fa; }

.dark .bd-hero        { background: #1e293b; border-color: #334155; }
.dark .bd-title       { color: #f1f5f9; }
.dark .bd-desc        { color: #94a3b8; }
.dark .bd-meta-label  { color: #64748b; }
.dark .bd-meta-value  { color: #e2e8f0; }
.dark .bd-meta-value--price { color: #60a5fa; }
.dark .bd-meta-value--mono  { color: #94a3b8; }

.dark .bd-badge--active   { color: #34d399; background: rgba(16,185,129,0.12); }
.dark .bd-badge--expired  { color: #f87171; background: rgba(239,68,68,0.12); }
.dark .bd-badge--upcoming { color: #fbbf24; background: rgba(251,191,36,0.12); }

.dark .bd-section-title { color: #475569; }
.dark .bd-section-count { background: #0f172a; color: #60a5fa; }

.dark .bd-table-wrap  { border-color: #334155; }
.dark .bd-th          { background: #0f172a; color: #475569; border-color: #334155; }
.dark .bd-tr:hover    { background: #1e293b; }
.dark .bd-tr:not(:last-child) { border-color: #1e293b; }
.dark .bd-td          { color: #e2e8f0; }
.dark .bd-td--highlight { color: #60a5fa; }
.dark .bd-prod-name    { color: #e2e8f0; }
.dark .bd-prod-barcode { color: #475569; }
.dark .bd-expiry-pill          { color: #94a3b8; background: #1e293b; border-color: #334155; }
.dark .bd-expiry-pill--expired { color: #f87171; background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.3); }
.dark .bd-uom-pill    { background: rgba(5,150,105,0.15); color: #34d399; }
.dark .bd-batch-pill  { background: rgba(124,58,237,0.15); color: #a78bfa; border-color: rgba(167,139,250,0.3); }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/BundleDetail/index.css"],"names":[],"mappings":"AAAA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;AACA,qBAAqB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAEjF,0BAA0B;AAC1B;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,OAAO;AACT;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;AACA,sBAAsB,cAAc,EAAE,mBAAmB,EAAE;AAC3D,sBAAsB,cAAc,EAAE,mBAAmB,EAAE;AAC3D,sBAAsB,cAAc,EAAE,mBAAmB,EAAE;;AAE3D;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gBAAgB,qCAAqC,EAAE;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B,uBAAuB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;AACrB;AACA,oFAAoF;AACpF,kBAAkB,gBAAgB,EAAE,UAAU,EAAE,gBAAgB,EAAE;AAClE,kBAAkB,iBAAiB,EAAE,YAAY,EAAE;;AAEnD,iCAAiC;AACjC,kBAAkB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAE7E,SAAS,4BAA4B,EAAE;AACvC,0BAA0B,gCAAgC,EAAE;AAC5D,eAAe,mBAAmB,EAAE;;AAEpC,SAAS,gBAAgB,EAAE,sBAAsB,EAAE,cAAc,EAAE;AACnE,kBAAkB,gBAAgB,EAAE;AACpC,kBAAkB,kBAAkB,EAAE;AACtC,kBAAkB,iBAAiB,EAAE,kCAAkC,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC9G,oBAAoB,cAAc,EAAE,gBAAgB,EAAE;;AAEtD,mBAAmB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnG,mBAAmB,eAAe,EAAE,eAAe,EAAE,cAAc,EAAE,wCAAwC,EAAE;AAC/G;EACE,qBAAqB,EAAE,eAAe;EACtC,eAAe,EAAE,gBAAgB;EACjC,cAAc,EAAE,mBAAmB,EAAE,yBAAyB;EAC9D,oBAAoB,EAAE,gBAAgB;AACxC;AACA;EACE,cAAc,EAAE,mBAAmB,EAAE,qBAAqB;AAC5D;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,yCAAyC;EACzC,sDAAsD;EACtD,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;iDAEiD;AACjD,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACpF,2BAA2B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAEvF,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE;AACpE,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE;AACxC,8BAA8B,cAAc,EAAE;AAC9C,8BAA8B,cAAc,EAAE;;AAE9C,4BAA4B,cAAc,EAAE,iCAAiC,EAAE;AAC/E,4BAA4B,cAAc,EAAE,gCAAgC,EAAE;AAC9E,4BAA4B,cAAc,EAAE,iCAAiC,EAAE;;AAE/E,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,mBAAmB,EAAE,cAAc,EAAE;;AAE/D,wBAAwB,qBAAqB,EAAE;AAC/C,wBAAwB,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACpF,wBAAwB,mBAAmB,EAAE;AAC7C,gCAAgC,qBAAqB,EAAE;AACvD,wBAAwB,cAAc,EAAE;AACxC,0BAA0B,cAAc,EAAE;AAC1C,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,iCAAiC,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC7F,iCAAiC,cAAc,EAAE,gCAAgC,EAAE,iCAAiC,EAAE;AACtH,wBAAwB,gCAAgC,EAAE,cAAc,EAAE;AAC1E,wBAAwB,iCAAiC,EAAE,cAAc,EAAE,mCAAmC,EAAE","sourcesContent":["/* ════════════════════════════════════════════\n   BUNDLE DETAIL PANEL\n   ════════════════════════════════════════════ */\n.bd-root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n/* ── Top bar with back button ── */\n.bd-topbar {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px 6px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.bd-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 10px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n}\n.bd-back-btn:hover { background: #f1f5f9; border-color: #2a71ff; color: #2a71ff; }\n\n/* ── Scrollable body ── */\n.bd-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 14px 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ── Hero card ── */\n.bd-hero {\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 14px 16px;\n  background: #fff;\n}\n\n.bd-hero-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 6px;\n}\n\n.bd-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.3;\n  flex: 1;\n}\n\n/* availability badge */\n.bd-badge {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 700;\n  border-radius: 999px;\n  padding: 3px 10px;\n}\n.bd-badge--active   { color: #067647; background: #ecfdf3; }\n.bd-badge--expired  { color: #b42318; background: #fef3f2; }\n.bd-badge--upcoming { color: #6d4c41; background: #fff8f0; }\n\n.bd-desc {\n  margin: 0 0 12px;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n/* Meta grid: 3-up on wider, 2-up on narrow */\n.bd-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px 12px;\n}\n\n@media (max-width: 540px) {\n  .bd-meta-grid { grid-template-columns: repeat(2, 1fr); }\n}\n\n.bd-meta-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.bd-meta-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n.bd-meta-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n}\n.bd-meta-value--price {\n  font-size: 16px;\n  color: #2a71ff;\n}\n.bd-meta-value--mono {\n  font-family: \"SFMono-Regular\", \"Consolas\", monospace;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #475569;\n}\n\n/* ── Products section ── */\n.bd-products-section { display: flex; flex-direction: column; gap: 10px; }\n\n.bd-section-title {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 11px;\n  font-weight: 800;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n}\n.bd-section-count {\n  background: #f1f5f9;\n  color: #2a71ff;\n  font-size: 10.5px;\n  font-weight: 700;\n  border-radius: 999px;\n  padding: 1px 8px;\n}\n\n.bd-no-products {\n  font-size: 12.5px;\n  color: #94a3b8;\n  padding: 20px 0;\n  text-align: center;\n}\n\n/* ── Table ── */\n.bd-table-wrap {\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.bd-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 11.5px;\n  table-layout: fixed;\n}\n\n.bd-th {\n  padding: 7px 6px;\n  background: #f8fafc;\n  font-size: 10px;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1.5px solid #e2e8f0;\n  white-space: nowrap;\n}\n/* 5 columns (UOM + Batch + Expiry as pills in Product cell): 38% + 4×15.5% ≈ 100% */\n.bd-th--product { text-align: left; width: 38%; min-width: 140px; }\n.bd-th--num     { text-align: right; width: 15.5%; }\n\n/* Pill row inside product cell */\n.bd-prod-pills  { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }\n\n.bd-tr { transition: background 0.12s; }\n.bd-tr:not(:last-child) { border-bottom: 1px solid #f1f5f9; }\n.bd-tr:hover { background: #f8fafc; }\n\n.bd-td { padding: 8px 6px; vertical-align: middle; color: #0f172a; }\n.bd-td--product { text-align: left; }\n.bd-td--center  { text-align: center; }\n.bd-td--num     { text-align: right; font-variant-numeric: tabular-nums; font-weight: 600; font-size: 11.5px; }\n.bd-td--highlight { color: #2a71ff; font-weight: 700; }\n\n.bd-prod-name    { margin: 0; font-size: 12px; font-weight: 600; color: #0f172a; line-height: 1.3; }\n.bd-prod-barcode { margin: 2px 0 0; font-size: 10px; color: #94a3b8; font-family: \"SFMono-Regular\", monospace; }\n.bd-expiry-pill {\n  display: inline-block; margin-top: 4px;\n  font-size: 10px; font-weight: 600;\n  color: #475569; background: #f1f5f9; border: 1px solid #e2e8f0;\n  border-radius: 999px; padding: 1px 7px;\n}\n.bd-expiry-pill--expired {\n  color: #b42318; background: #fef3f2; border-color: #fecaca;\n}\n\n.bd-batch-pill {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: rgba(124, 58, 237, 0.08);\n  color: #7c3aed;\n  border: 1px solid rgba(124, 58, 237, 0.2);\n  font-family: ui-monospace, \"SFMono-Regular\", monospace;\n  letter-spacing: 0.02em;\n}\n\n.bd-uom-pill {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #059669;\n  background: #ecfdf5;\n  border-radius: 999px;\n  padding: 2px 7px;\n}\n\n/* ════════════════════════════════════════════\n   DARK THEME\n   ════════════════════════════════════════════ */\n.dark .bd-topbar      { border-color: #1e293b; }\n.dark .bd-back-btn    { background: #1e293b; border-color: #334155; color: #94a3b8; }\n.dark .bd-back-btn:hover { background: #0f172a; border-color: #3b82f6; color: #60a5fa; }\n\n.dark .bd-hero        { background: #1e293b; border-color: #334155; }\n.dark .bd-title       { color: #f1f5f9; }\n.dark .bd-desc        { color: #94a3b8; }\n.dark .bd-meta-label  { color: #64748b; }\n.dark .bd-meta-value  { color: #e2e8f0; }\n.dark .bd-meta-value--price { color: #60a5fa; }\n.dark .bd-meta-value--mono  { color: #94a3b8; }\n\n.dark .bd-badge--active   { color: #34d399; background: rgba(16,185,129,0.12); }\n.dark .bd-badge--expired  { color: #f87171; background: rgba(239,68,68,0.12); }\n.dark .bd-badge--upcoming { color: #fbbf24; background: rgba(251,191,36,0.12); }\n\n.dark .bd-section-title { color: #475569; }\n.dark .bd-section-count { background: #0f172a; color: #60a5fa; }\n\n.dark .bd-table-wrap  { border-color: #334155; }\n.dark .bd-th          { background: #0f172a; color: #475569; border-color: #334155; }\n.dark .bd-tr:hover    { background: #1e293b; }\n.dark .bd-tr:not(:last-child) { border-color: #1e293b; }\n.dark .bd-td          { color: #e2e8f0; }\n.dark .bd-td--highlight { color: #60a5fa; }\n.dark .bd-prod-name    { color: #e2e8f0; }\n.dark .bd-prod-barcode { color: #475569; }\n.dark .bd-expiry-pill          { color: #94a3b8; background: #1e293b; border-color: #334155; }\n.dark .bd-expiry-pill--expired { color: #f87171; background: rgba(239,68,68,0.12); border-color: rgba(239,68,68,0.3); }\n.dark .bd-uom-pill    { background: rgba(5,150,105,0.15); color: #34d399; }\n.dark .bd-batch-pill  { background: rgba(124,58,237,0.15); color: #a78bfa; border-color: rgba(167,139,250,0.3); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
